import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { components } from 'react-select';
import Icon from '@mdi/react';

const SingleValue = ({ data, isIconAsValue = false, ...props }) => {
  const renderedValue = useMemo(() => (
    <div className={`flex ${isIconAsValue ? 'items-center justify-center' : 'gap-2'}`}>
      {data.icon && <Icon path={data.icon} size={1} />}
      {!isIconAsValue && data.label}
    </div>
  ), [data, isIconAsValue]);

  return <components.SingleValue {...props}>{renderedValue}</components.SingleValue>;
};

SingleValue.propTypes = {
  data: PropTypes.shape({
    icon: PropTypes.element,
    label: PropTypes.string.isRequired,
  }).isRequired,
  isIconAsValue: PropTypes.bool,
};

export default SingleValue;
